import styled, { css } from 'styled-components';

import promoColors from '../../../../theme/promoColors';
import promoMedia from '../../../../theme/promoMedia';

export const IconContainer = styled.span`
    width: ${(props) => (props.size === 'small' ? '20px' : '24px')};
    height: ${(props) => (props.size === 'small' ? '20px' : '24px')};
`;

const getBackground = (props) => {
    if (props.isDisabled) {
        return 'none';
    } else if (props.isSelected) {
        return promoColors.purple5;
    } else if (props.variant === 'primary') {
        return props.isInverted ? promoColors.white : promoColors.primary;
    } else {
        return 'none';
    }
};

const getIconColor = (props) => {
    if (props.isDisabled) {
        return promoColors.gray20;
    } else if (props.isNavButton && props.isNavButtonInverted) {
        return promoColors.white;
    } else if (props.isNavButton) {
        return promoColors.gray80;
    } else if ((props.variant === 'primary' && !props.isInverted) || (props.variant === 'secondary' && props.isInverted)) {
        return promoColors.white;
    } else {
        return promoColors.primary;
    }
};

const getIconHoverColor = (props) => {
    if (props.isDisabled) {
        return promoColors.gray20;
    } else if (props.isNavButton && props.isNavButtonInverted) {
        return promoColors.white;
    } else if (props.isNavButton) {
        return promoColors.gray80;
    } else {
        return promoColors.primary;
    }
};

const CommonCss = css`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    background: ${(props) => getBackground(props)};
    border-radius: 50%;
    width: ${(props) => (props.size === 'small' ? '40px' : '48px')};
    height: ${(props) => (props.size === 'small' ? '40px' : '48px')};
    padding: 0;
    border: none;
    box-sizing: border-box;
    cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};
    pointer-events: ${(props) => (props.isDisabled ? 'none' : null)};
    box-shadow: none;

    ${IconContainer} {
        svg {
            --accent: ${(props) => getIconColor(props)};
        }
    }

    &:hover,
    &:active,
    &:focus {
        background: ${(props) => (props.isDisabled || props.isNavButton ? 'none' : promoColors.purple20)};
    }

    @media (hover: hover) {
        &:hover,
        &:active,
        &:focus {
            background: ${(props) => (props.isDisabled || props.isNavButton ? 'none' : promoColors.purple20)};

            ${IconContainer} {
				svg {
					--accent: ${(props) => getIconHoverColor(props)};
				}
			}
    }

    ${promoMedia.desktop1440} {
        width: ${(props) => (props.size === 'small' ? '48px' : '80px')};
        height: ${(props) => (props.size === 'small' ? '48px' : '80px')};

        ${IconContainer} {
            width: ${(props) => (props.size === 'small' ? '24px' : '48px')};
            height: ${(props) => (props.size === 'small' ? '24px' : '48px')};
        }
    }
`;

export const CommonButton = styled.button`
    ${CommonCss};

    &:focus-visible {
        background-color: ${promoColors.purple80};
        outline: 1px dashed ${promoColors.purple};
    }
`;
export const LinkButton = styled.a`
    ${CommonCss};
`;
export const PseudoButton = styled.span`
    ${CommonCss};
`;
